import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import TrapThdata from '../entities/trapthdata'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface DataState extends ListState<TrapThdata>{
    editData:TrapThdata
}
class UserMutations extends ListMutations<TrapThdata>{

}
class DataModule extends ListModule<DataState,any,TrapThdata>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<TrapThdata>(),
        loading:false,
        editData:new TrapThdata()
    }
    actions={
        async getAllPaged(context:ActionContext<DataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/TrapThdata/GetAllPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<TrapThdata>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getWarningPaged(context:ActionContext<DataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/TrapThdata/GetWarningPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<TrapThdata>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getWareHouseList(context:ActionContext<DataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/TrapThdata/GetWareHouseList',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<TrapThdata>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return 1;
        },
        async getPaged(context:ActionContext<DataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/TrapThdata/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<TrapThdata>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPagedLast(context: ActionContext<DataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TrapThdata/GetPagedLast', { params: payload.data });
            let page = reponse.data.result as PageResult<TrapThdata>;
            return page.items;
        },
        async create(context:ActionContext<DataState,any>,payload:any){
            await Ajax.post('/api/services/app/TrapThdata/Create',payload.data);
        },
        async update(context:ActionContext<DataState,any>,payload:any){
            await Ajax.put('/api/services/app/TrapThdata/Update',payload.data);
        },
        async delete(context:ActionContext<DataState,any>,payload:any){
            await Ajax.delete('/api/services/app/TrapThdata/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<DataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/TrapThdata/GetById?Id='+payload.id);
            return reponse.data.result as TrapThdata;
        },
        async getWarning(context:ActionContext<DataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/TrapThdata/GetWarningList');
            return reponse.data.result.items;
        },
        async getRank(context:ActionContext<DataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/TrapThdata/GetRankList?day='+payload.data);
            return reponse.data.result.items;
        }

    };
    mutations={
        setCurrentPage(state:DataState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:DataState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:DataState,data:TrapThdata){
            
            state.editData=data;
            //console.log(state.editFloor);
        }
    }
}
const dataModule=new DataModule();
export default dataModule;